"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../theme");
var baseButton = {
    fontWeight: "normal",
    textTransform: "uppercase",
    fontSize: "0.8em",
};
exports.useStyles = (0, react_jss_1.createUseStyles)({
    component: {},
    label: __assign({}, theme_1.label),
    options: {
        display: "flex",
        gap: (0, theme_1.space)(),
    },
    button: __assign(__assign(__assign({}, theme_1.buttons.secondary), baseButton), { "--on-button-color": theme_1.colors.neutral90, "--button-color": "white", border: "1px solid " + theme_1.colors.primary, boxSizing: "border-box" }),
    selected: __assign(__assign(__assign({}, theme_1.buttons.primary), baseButton), { border: "1px solid " + theme_1.colors.primary })
});
